export type TagNode = {
  [tag: string]: TagNode;
};

const hierarchy: TagNode = {
  "Programming Languages & Frameworks": {
    "Low-level Programming Languages": {
      "C": {},
      "C++": {},
      "Rust": {}
    },
    "High-level Programming Languages": {
      "Python": {},
      "TypeScript": {},
      "JavaScript": {},
      "Java": {},
      "Go": {},
      "Kotlin": {},
      "Swift": {},
      "C#": {},
      "MATLAB": {}
    },
    "Frameworks": {
      "Frontend Frameworks": {
        "React": {},
        "Vue.js": {},
        "NextJS": {}
      },
      "Backend Frameworks": {
        "Django": {},
        "Flask": {},
        "Android": {}
      }
    },
    "Compilers & Tooling": {
      "LLVM": {},
      "WebAssembly": {},
      "GCC": {},
      "Clang": {},
      "TypeScript Compiler": {},
      "JIT": {},
      "CMake": {},
      "Numba": {}
    }
  },
"Tools & Libraries": {
  "Shared Libraries": {
    "Scientific Computing": {
      "NumPy": {},
      "Pandas": {},
      "SciPy": {},
      "Matplotlib": {},
      "scikit-learn": {},
      "scikit-image": {}
    },
    "Machine Learning Libraries": {
      "TensorFlow": {},
      "PyTorch": {},
      "Keras": {},
      "JAX": {},
      "OpenCV": {},
      "Transformers": {},
      "Hugging Face": {},
      "spaCy": {},
      "NLTK": {}
    },
    "Model Deployment & Interfaces": {
            "FastAPI": {},
            "Streamlit": {},
            "Gradio": {}
          }
  },
  "Development Tools & IDEs": {
    "Editors": {
      "VSCode": {},
      "Vim": {},
      "Emacs": {}
    },
    "Tooling": {
      "Git": {},
      "Bash": {},
      "Make": {},
      "CMake": {},
      "Jupyter": {}
    }
  },
  "Data Visualization": {
    "Matplotlib": {},
    "Plotly": {},
    "D3.js": {},
    "ThreeJS": {}
  }
},

  "Machine Learning & Deep Learning": {
        "Neural Network Types": {
          "DNN": {},
          "CNN": {},
          "RNN": {},
          "LSTM": {},
          "GRU": {},
          "MLP": {},
          "PointNet": {}
        },
        "Modern Architectures": {
          "Transformer": {},
          "BERT": {},
          "GPT": {},
          "Diffusion Models": {},
          "Vision Transformer": {},
          "CLIP": {},
          "SAM": {},
          "NeRF": {},
          "LoRA": {},
          "RLHF": {}
        },
        "Learning Paradigms": {
          "Supervised Learning": {},
          "Unsupervised Learning": {},
          "Semi-Supervised Learning": {},
          "Self-Supervised Learning": {},
          "Transfer Learning": {},
          "Few-Shot Learning": {},
          "Reinforcement Learning": {},
          "Online Learning": {},
          "Contrastive Learning": {}
        },
         "Tasks by Domain": {
            "Vision": {
              "Image Classification": {},
              "Object Detection": {},
              "Image Segmentation": {},
              "Image Generation": {},
              "SLAM": {}
            },
            "NLP": {
              "Language Modeling": {},
              "Sentiment Analysis": {},
              "Text Classification": {},
              "Machine Translation": {},
              "Question Answering": {}
            },
            "General": {
              "Classification": {},
              "Regression": {},
              "Clustering": {},
              "Dimensionality Reduction": {},
              "Segmentation":{}
            }
          },
        "Deep Learning": {
          "Deep Q-Learning": {},
          "Object Classification": {},
          "Object Detection": {},
          "Image Segmentation": {},
          "Image Generation": {},
          "Neural Style Transfer": {},
          "Speech Recognition": {},
          "Language Modeling": {},
          "Attention Mechanisms": {},
          "Multi-Modal Learning": {},
          "Encoder-Decoder Architectures": {},
          "Meta Learning": {},
          "Curriculum Learning": {}
        },
        "Machine Learning": {
          "Supervised Learning": {
            "SVM": {},
            "KNN": {},
            "Decision Trees": {},
            "Random Forest": {},
            "Gradient Boosting": {},
            "Naive Bayes": {},
            "Linear Regression": {},
            "Logistic Regression": {}
          },
          "Unsupervised Learning": {
            "K-Means Clustering": {},
            "Hierarchical Clustering": {},
            "DBSCAN": {},
            "Mixture of Gaussians": {},
            "Dimensionality Reduction": {},
            "Anomaly Detection": {}
          },
          "Reinforcement Learning": {
            "Multi-Agent Reinforcement Learning (MARL)":{},
            "Q-Learning": {},
            "SARSA": {},
            "Deep Q-Networks (DQN)": {},
            "Policy Gradient Methods": {},
            "Actor-Critic Methods": {},
            "Monte Carlo Methods": {},
            "Temporal Difference Learning": {},
            "Memory Abstraction":{
              "Replay Memory":{},
              "Episodic Memory":{},
              "Semantic Memory":{}
            }
          },
          "Probabilistic Models": {
            "Hidden Markov Models": {},
            "Baum-Welch": {},
            "Forward-Backward Algorithm": {},
            "Bayesian Networks": {}
          },
          "Ensemble Learning": {
            "Bagging": {},
            "Boosting": {},
            "Stacking": {}
          }
        },
        "State Abstraction":{
              "Equivariance":{},
              "Invariance":{}
        },
        "Pattern Detection":{

        },
        "Model Validation":{
          "Monte-Carlo Trials":{}
        }
  },
"Computer Vision": {
  "Low-Level Vision": {
    "Image Processing": {
      "Edge Detection": {},
      "Morphological Operations": {},
      "Histogram Equalization": {},
      "Image Filtering": {},
      "Super Resolution": {}
    },
    "Optical Flow Estimation": {},
    "Stereo Depth Estimation": {}
  },
  "Mid-Level Vision": {
    "Image Segmentation": {},
    "Object Detection": {},
    "Object Classification": {},
    "3D Perception": {},
    "Pose Estimation": {},
    "Gaze Tracking": {}
  },
  "High-Level Vision": {
    "Action Recognition": {},
    "Object Tracking": {},
    "Facial Recognition": {},
    "OCR": {},
    "Image Generation": {},
    "Visual SLAM": {},
    "Underwater Vision": {}
  },
  "3D Deep Learning": {
    "Stereo Vision": {},
    "Structure from Motion": {},
    "Multi-view Geometry": {},
    "3D Reconstruction": {},
    "3D Modeling": {},
    "3D Registration": {},
    "Point Cloud": {},
    "Scene Reconstruction": {},
    "3D Segmentation": {},
    "Mesh Processing": {},
    "Voxel Networks": {}
  }
},
  "AI & Search Algorithms": {
    "Artificial Intelligence": {
      "AI Fundamentals": {
        "AI Agent": {},
        "AI Planning": {},
        "Heuristics": {},
        "Turing Test": {},
        "Symbolic vs Statistical AI": {}
      },
      "Adversarial Search": {
        "Minimax": {},
        "Alpha-Beta Pruning": {},
        "Monte Carlo Tree Search": {},
        "Deadlock Detection": {}
      },
      "Learning Paradigms": {
        "Reinforcement Learning": {},
        "Supervised Learning": {},
        "Unsupervised Learning": {},
        "Self-Supervised Learning": {}
      },
      "Knowledge Representation": {
        "Logic-Based": {
          "Propositional Logic": {},
          "First-Order Logic": {}
        },
        "Rule-Based Systems": {},
        "Ontologies": {},
        "Semantic Networks": {},
        "Knowledge Graphs": {}
      },
      "Features":{
        MFCC:{},
      },
      "Reasoning & Inference": {
        "Deductive Reasoning": {},
        "Inductive Reasoning": {},
        "Abductive Reasoning": {},
        "Probabilistic Reasoning": {
          "Bayesian Networks": {},
          "Markov Models": {},
          "Hidden Markov Models": {},
          "Fuzzy Logic": {},
          "Bayesian Methods": {}
        }
      },
      "NLP (Natural Language Processing)": {
        "Syntax Parsing": {},
        "Named Entity Recognition": {},
        "Sentiment Analysis": {},
        "Transformers": {}
      },
      "Ethics & Safety": {
        "Explainability": {},
        "Bias in AI": {},
        "AI Safety": {},
        "Responsible AI": {}
      }
    },

    "Graph Algorithms & Game AI": {
      "Graph Algorithms": {
        "Search Algorithms": {
          "DFS (Depth-First Search)": {},
          "BFS (Breadth-First Search)": {},
          "Dijkstra's Algorithm": {},
          "Bellman-Ford Algorithm": {},
          "A* Search": {},
          "Binary Search": {},
        },
        "Graph Theory": {},
        "Graph Visualization": {},
        "Graph Optimization": {
          "Minimum Spanning Tree": {
            "Prim's Algorithm": {},
            "Kruskal's Algorithm": {}
          },
          "Network Flow": {},
          "Graph Partitioning": {}
        },
        "Graph Pruning": {
          "Minimax Pruning": {},
          "Alpha-Beta Pruning": {},
          "Monte Carlo Tree Search": {}
        }
      },
      "Game AI": {
        "Minimax Algorithm": {},
        "Alpha-Beta Pruning": {},
        "Monte Carlo Tree Search": {},
        "Deadlock Detection": {}
      }
    }
  },



  "Control Systems & Robotics": {
    "Control Systems": {
      MPC: {},
      "Hybrid MPC": {},
      "Adaptive-Control": {},
      "PID Control": {},
      "Optimal Control": {},
      "Traffic Control":{
        "Congestion Control":{}
      }
    },
    "Signal Processing": {
      "Speech Recognition": {},
      "Fourier Transform": {},
      "Fast Fourier Transform (FFT)": {},
      "Digital Filtering": {},
      "Low-Pass Filters": {},
      "High-Pass Filters": {},
      "Band-Pass Filters": {},
      "Wavelet Transform": {},
      "Spectral Analysis": {},
      "Z-Transform": {},
      "Laplace Transform": {},
      "Discrete-Time Signal Processing": {},
      "Noise Reduction": {},
      "Sampling and Quantization": {},
      "Filter Design": {},
      "Time-Frequency Analysis": {},
      "System Response Analysis": {},
      "Sensor Signal Conditioning": {},
      "Signal Reconstruction": {},
      "Adaptive Filtering": {},
      "Hilbert Transform": {}
    },
    "System Identification": {
      "Model Types": {
        "Linear System Identification": {},
        "Nonlinear System Identification": {}
      },
      "Parametric Models": {
        "ARX": {},
        "ARMAX": {},
        "OE (Output Error)": {},
        "Box-Jenkins": {},
        "State Space Models": {}
      },
      "Nonparametric Methods": {
        "Frequency Response Analysis": {},
        "Correlation Methods": {},
        "Spectral Analysis": {},
        "Kernel Regression": {},
        "Gaussian Processes": {}
      },
      "Estimation Techniques": {
        "Parameter Estimation": {
          "Least Squares": {},
          "Recursive Least Squares": {},
          "Maximum Likelihood": {},
          "Bayesian Estimation": {}
        },
        "State Estimation": {
          "Kalman Filter": {},
          "Extended Kalman Filter": {},
          "Unscented Kalman Filter": {},
          "Particle Filter": {}
        }
      },
      "Model Validation": {
        "Cross-Validation": {},
        "Residual Analysis": {},
        "Prediction Error": {},
        "Fit Percentage": {}
      },
      "System Modeling & Dynamics": {
        "System Modeling": {},
        "System Dynamics": {},
        "Dynamical Systems": {}
      }
    },

    Robotics: {
      SLAM: {},
      "Path Planning": {},
      "Autonomous Navigation": {},
      "Mobile Robotics": {},
      "Frenet Planner": {},
      "Sensor Fusion": {},
      "Integration": {}
    },
    "Perception & Sensors": {
      IMU: {},
      LiDAR: {},
      Cameras: {},
      Encoders: {},
      "Sensor Fusion":{},
    },
    "Communication & Interfaces": {
      "CAN Bus": {},
      I2C: {},
      SPI: {},
      UART: {}
    },
    "Simulation & Platforms": {
      Gazebo: {},
      Rviz2: {},
      "Carla Simulator": {},
      Webots: {},
      IsaacSim: {},
      "V-REP": {},
      "ROS2": {},
      "Carla": {},
      "ROS": {},
      "CATKIN Workspace": {}
    },
    "Embedded & Hardware": {
      Arduino: {},
      Embedded: {},
      Hardware: {},
      CAD: {},
      PCB: {},
      FPGA: {},
      Microcontrollers: {},
      RTOS: {},
      "Real-Time Scheduling": {}
    },
    "Energy & Smart Systems": {
      "Smart Grid": {
        HEMS: {},
        "Energy Optimization": {},
        "Battery Storage": {},
        "Heat Pump Control": {},
        "Load Forecasting": {}
      }
    },
  },

"Graphics & Visualization": {
  "Computer Graphics": {
    "Computational Geometry": {
      "Polygon Cutting": {
        "Convex Partitioning": {}
      },
      "Geometric Algorithms": {
        "Routing Geometry": {}
      },
      "Polygon Clipping": {
        "Cut Operations": {}
      },
      "Geometric Data Structures": {
        "Doubly Connected Edge List (DCEL)": {
          "DCEL Cutting Operation": {}
        }
      },
      "Voronoi Diagram": {
        "Watchtower Regions": {}
      }
    },
    "Graphics Pipeline": {
      "Rendering": {
        "Rasterization": {},
        "Ray Tracing": {
          "Reflection & Refraction": {},
          "Anti-Aliasing": {},
          "Snell's Law": {},
          "Fresnel Effect": {},
          "OBJ Model Support": {},
          "Custom Camera Orientation": {},
          "Shadows":{}
        }
      }
    },
    "Rendering Engines": {
      "OpenGL": {},
      "WebGL": {},
      "Vulkan": {},
      "Unity": {
        "Shader Development": {
          "Phong Illumination Model": {},
          "Gouraud Shading": {},
          "Lighting Pipeline Implementation": {}
        }
      },
      "Unreal": {},
      "Godot": {}
    },
    "Shaders & Effects": {
      "Shader Engines": {
        "Cg": {},
        "GLSL": {},
        "HLSL": {
          "Unity HLSL": {}
        },
        "Physically Based Rendering": {},
        "GPGPU": {}
      },
      "Shader methods": {
        "Phong Shading": {},
        "Gouraud Shading": {},
        "Lighting Models": {
          "Vertex-Based Lighting": {},
          "Fragment-Based Lighting": {}
        }
      }
    },
    "3D Modeling": {
      "Blender": {},
      "Mesh Processing": {
        "Triangle Meshes": {},
        "OBJ Parsing": {}
      },
      "Ray Tracing": {
        "Recursive Ray Tracing": {},
        "Ray-Object Intersection": {}
      },
      "Shaders": {}
    },
    "Procedural Generation": {
      "Wave Function Collapse": {},
      "Level Design": {}
    }
  },
  "Visualization": {
    "D3": {},
    "Matplotlib": {},
    "Plotly": {},
    "Graph Visualization": {},
    "ThreeJS": {}
  },
  "Game": {
    "Game Design": {
      "Level Design": {},
      "Gameplay Design": {},
      "3D Modelling": {}
    },
    "3D Platformer": {},
    "Playtesting": {}
  }
},

"Math & Theory": {
  "Linear Algebra": {
    "Matrix Decompositions": {},
    "Spectral Theory": {}
  },
  "Numerical Optimization": {
    "Convex Optimization": {},
    "Gradient-Based Methods": {},
    "Constrained Optimization": {}
  },
  "Probability & Statistics": {
    "Probability Distributions": {},
    "Bayesian Inference": {},
    "Hypothesis Testing": {},
    "Stochastic Processes": {
      "Markov Chains": {},
      "Markov Decision Processes": {},
      "Martingales": {},
      "Poisson Processes": {}
    }
  },
  "Information Theory": {
    "Entropy & Mutual Information": {},
    "KL Divergence": {},
    "Data Compression": {}
  },
  "Graph Theory": {
    "Graph Traversal": {},
    "Spectral Graph Theory": {},
    "Random Graphs": {}
  },
  "Physics": {
    "Symmetry":{},
    "Classical Mechanics": {
      "Noether's Theorem": {},
      "Lagrangian Mechanics":{},
      "Hamiltonian Mechanics":{},
      "Energy Conservation":{},
    },
    "Statistical Mechanics": {},
    "Dynamical Systems": {}
  },
  "Game Theory": {
    "Nash Equilibrium": {},
    "Stochastic Games": {}
  },
  "Control Theory": {
    "Feedback Control": {},
    "Optimal Control": {},
    "Stochastic Control": {}
  },
  "Calculus & Analysis": {
    "Real Analysis": {},
    "Multivariable Calculus": {},
    "Differential Equations": {}
  }
},


  "Data Science & Analysis": {
    "Data Analysis": {
      "High-Dimensional Data": {},
      "Statistical Noise": {},
      "Correlation Structure": {},
      "Exploratory Analysis": {},
      "Time Series Forecasting": {},
      "Financial Analysis": {}
    },
    "Scientific Computing": {
      NumPy: {},
      Pandas: {},
      SciPy: {},
      "scikit-learn": {},
      "scikit-image": {},
      Matplotlib: {}
    },
    "Optimization & Math Tools": {
      "Optimal Transport": {},
      "Wasserstein Distance": {},
      JAX: {},
      "ott-jax": {}
    }
  },

  "Web Development & DevOps": {
    Frontend: {
      HTML: {},
      CSS: {},
      JavaScript: {},
      TypeScript: {},
      React: {},
      Tailwind: {},
      NextJS: {},
      "Vue.js": {},
      "WASM": {}
    },
    Backend: {
      NodeJS: {},
      Express: {},
      Django: {},
      Flask: {},
      GraphQL: {}
    },
    DevOps: {
      Docker: {},
      Kubernetes: {},
      GitHubActions: {},
      Jenkins: {},
      CI_CD: {}
    },
    "Dev Tools & IDEs": {
      Editors: {
        VSCode: {},
        Vim: {},
        Emacs: {}
      },
      Tooling: {
        Git: {},
        Bash: {},
        Make: {},
        CMake: {},
        Jupyter: {}
      }
    }
  },

  "Networking & Systems": {
    Networking: {
      "Netowrking Protocols": {
        Routing: {
          BGP: {},
          OSPF: {},
          EIGRP: {},
          RIP: {},
          "IS-IS": {},
          Static_Routing: {}
        },
        Switching: {
          STP: {},
          RSTP: {},
          MSTP: {},
          VLAN: {}
        },
        Application: {
          HTTP: {},
          HTTPS: {},
          MQTT: {},
          DNS: {},
          DHCP: {},
          SNMP: {}
        },
        Transport: {
          TCP: {},
          UDP: {}
        },
        Network: {
          IP: {},
          ICMP: {},
          ARP: {},
          NAT: {}
        },
        Security: {
          IPsec: {},
          SSL_TLS: {},
          SSH: {}
        }
      },
      "Network Tech": {
        SONiC: {},
        YANG: {},
        Redis: {},
        Netconf: {},
        RESTCONF: {},
        OpenFlow: {},
        VXLAN: {},
        EVPN: {},
        SDN: {},
        NFV: {}
      },
      "Network Tools": {
        GNS3: {},
        Wireshark: {},
        FRRouting: {},
        CiscoPacketTracer: {},
        Nmap: {},
        Ansible: {},
        Netmiko: {},
        Pcap: {}
      },
      Monitoring_and_Management: {
        Prometheus: {},
        Grafana: {},
        Zabbix: {},
        Nagios: {},
        Telegraf: {}
      }
    },

    "Operating Systems": {
      Linux: {},
      "Embedded OS": {},
      RTOS: {}
    },
    "Distributed Systems": {
      "Data Center": {},
      Kubernetes: {},
      "Message Queues": {},
      "Sensor Networks":{},

    }
  },



  "Localization & Wireless": {
    Bluetooth: {
      CTE: {},
      RSSI: {},
      Beamforming: {}
    },
    "Localization & Tracking": {
      Localisation: {},
      Positioning: {},
      Tracking: {},
      SLAM: {}
    }
  },

  "Applications & Domains": {
    "Biomedical Engineering": {
      Tracheostomy: {},
      "Health Monitoring": {},
      "Wearable Devices": {},
      "Assistive Technology":{
        Ophthalmodynamometry:{
          "Intracranial Pressure":{}
        },
        "Medical Device":{},
      },
      "Brain Computer Interface (BCI)":{
        "EEG": {},
        "Motor Imagery": {},
        "Multiple Sclerosis": {},
        "Neuroengineering": {},
        "Source-Level Analysis": {},
        "Alpha Power": {},
        "Beta Band": {},
        "Dipole Fitting":{},
      }
    },
    "Autonomous Systems": {
      "Self-driving Cars": {},
      "Marine Robotics": {}
    },
    Gaming: {
      "Board Games": {},
      "Puzzle Solvers": {},
      Sokoban: {}
    },
    Education: {
      Hackathon: {},
      Portfolio: {},
      "Open Source": {}
    }
  },
  Internship:{
    "Microsoft": {},
    "Museums Victoria": {},
    "John NeuroBionics Lab": {}
  },


};

export { hierarchy };
